export default class RealtimeEntity {
  constructor () {
    this.bed = {
      breath: [],
      heart: [],
      move: [],
    };
  }
}

if (Utils.isDebug()) {
  window.RealtimeEntity = RealtimeEntity;
}
